module.exports = __webpack_public_path__ + "media/question1_en.02e02293.mp3";